// extracted by mini-css-extract-plugin
module.exports = {"intro":"user-attribute-add_intro__2Epeb","title":"user-attribute-add_title__D856x"};